module.exports = __webpack_public_path__ + "amount-authorized.png?d3e823e785adfb5f258aca67098d4650";